import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-body tw-mr-5 tw-mt-2" }
const _hoisted_2 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR WEEK"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WEEKS FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_4 = { class: "data" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center b-0" }, " $ ", -1)
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "tw-flex tw-justify-around tw-items-center tw-mt-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_12 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

import { toRefs, watch } from 'vue';
import { currencyFormat } from '@/composables/filters';


export default /*#__PURE__*/_defineComponent({
  __name: 'IncomeWeekly',
  props: {
  weeklyIncome: {
    type: Array,
    default: []
  }
},
  setup(__props) {

const props = __props;


const { weeklyIncome }: any = toRefs(props)

// Watch the entire array for changes
watch(weeklyIncome, (newItems) => {
  newItems.forEach((item, index) => {
    // Calculate monthly income for each item
    if (item.paymentForWeek > 0 && item.monthsForYear > 0 && item.weeksForMonth > 0) {

      const weekIncome = (item.weeksForMonth + 0.33) * item.paymentForWeek;
      const monthlyIncome = item.monthsForYear * weekIncome;
      const yearlyIncome = monthlyIncome / 12;

      // Update the monthlyIncome in the array
      weeklyIncome.value[index].monthlyIncome = yearlyIncome || 0;
    }
  });
}, { deep: true });

const removeIncomeType = (index) => {
  weeklyIncome.value.splice(index, 1)
}

const addIncomeType = () => {
  weeklyIncome.value.push({
    paymentForWeek: 0,
    weeksForMonth: 0,
    monthsForYear: 0,
    monthlyIncome: 0
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weeklyIncome), (week, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "w-full b-0",
                    placeholder: "0.00",
                    min: "0",
                    "onUpdate:modelValue": ($event: any) => ((week.paymentForWeek) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelText, week.paymentForWeek]
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((week.weeksForMonth) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelText, week.weeksForMonth]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((week.monthsForYear) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, week.monthsForYear]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(currencyFormat)(week.monthlyIncome)), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (index > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                onClick: ($event: any) => (removeIncomeType(index))
              }, _hoisted_16, 8, _hoisted_14))
            : _createCommentVNode("", true),
          (_unref(weeklyIncome).length == index + 1 && index != 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addIncomeType()))
              }, _hoisted_18))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 256))
  ]))
}
}

})